import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CofOStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-cof-ostatus',
  templateUrl: './cof-ostatus.component.html',
  styleUrls: ['./cof-ostatus.component.scss'],
})
export class CofOStatusComponent implements OnChanges {
  cofostatusForm: FormGroup;
  cofostatusFormArray: FormGroup;
  control = new FormControl();
  @Input() cofostatuss: CofOStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() cofostatus = new EventEmitter<CofOStatusDto[]>();
  @Output() deleteCofOStatusEvent = new EventEmitter<any>();

  selectedCofOStatus: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createCofOStatusForm();
  }

  createCofOStatusForm() {
    this.cofostatusForm = this.fb.group({
      CofOStatusName: ['', Validators.required],
      COfODate: ['', Validators.required],
      id: null,
    });
    this.cofostatusFormArray = this.fb.group({
      CofOStatuss: this.fb.array([]),
    });
    this.setCofOStatus();
  }

  // method to display cofostatuss
  setCofOStatus() {
    const control = this.cofostatusFormArray.controls.CofOStatuss as FormArray;
    this.cofostatuss.forEach((e) => {
      control.push(
        this.fb.group({
          CofOStatusName: e.CofOStatusName,
          COfODate: e.COfODate,
          id: e.id,
        })
      );
    });
  }

  // method to add CofOStatus
  addCofOStatus(value: CofOStatusDto) {
    const control = this.cofostatusFormArray.controls.CofOStatuss as FormArray;
    control.insert(
      0,
      this.fb.group({
        CofOStatusName: value.CofOStatusName,
        COfODate: value.COfODate,
        id: null,
      })
    );
  }

  selectCofOStatus(value) {}

  // method to delete cofostatus from arrary list
  deleteCofOStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.cofostatusFormArray.controls
          .CofOStatuss as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.cofostatuss.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.cofostatuss[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: CofOStatusDto) {
    if (this.cofostatusForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.cofostatusFormArray
        .get('CofOStatuss')
        ['controls'][this.selectedIndex].patchValue({
          CofOStatusName: formValue.CofOStatusName,
        });
    } else {
      this.addCofOStatus(formValue);
    }
    this.selectedIndex = null;
    this.cofostatusForm.reset();
  }

  onEdit(index, value: CofOStatusDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.cofostatusForm.patchValue({ CofOStatusName: value.CofOStatusName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.cofostatusForm.reset();
  }

  onSubmit(formValue: CofOStatusDto[]) {
    this.cofostatus.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteCofOStatusEvent.emit(this.filteredDelete);
    }
  }
}
